import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

// Crear instancia de Axios
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 10000
});

// Interceptor de request - enviar token correcto segun contexto
api.interceptors.request.use(
  (config) => {
    const url = config.url || '';
    const isAdminCall = url.includes('/admin/');

    // 1. Authorization header
    const adminToken = localStorage.getItem('admin_jwt');
    if (isAdminCall && adminToken) {
      // Admin API calls use admin JWT
      config.headers.Authorization = `Bearer ${adminToken}`;
    } else if (!isAdminCall) {
      // User API calls use legacy JWT if available
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    // 2. Always send wallet address + signature (backend authenticateWallet requires both)
    const walletAddress = localStorage.getItem('walletAddress');
    if (walletAddress) {
      config.headers['x-wallet-address'] = walletAddress;
    }

    const walletSignature = sessionStorage.getItem('walletSignature') || localStorage.getItem('walletSignature');
    const walletMessage = sessionStorage.getItem('walletMessage') || localStorage.getItem('walletMessage');
    if (walletSignature && walletMessage) {
      config.headers['x-wallet-signature'] = walletSignature;
      config.headers['x-wallet-message'] = walletMessage;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor de response - manejar errores globalmente
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Manejar error 401 (no autorizado)
    if (error.response?.status === 401) {
      const url = error.config?.url || '';
      if (url.includes('/admin/')) {
        // Only clear admin JWT for admin API 401s
        localStorage.removeItem('admin_jwt');
      } else {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
      // Only clear wallet auth on explicit expiry — Web3Context handles re-signing
      const errorMsg = error.response?.data?.message || '';
      if (errorMsg.includes('Firma expirada')) {
        localStorage.removeItem('walletSignature');
        localStorage.removeItem('walletMessage');
        localStorage.removeItem('walletSignatureAddr');
        // Notify Web3Context to prompt a fresh MetaMask signature immediately
        window.dispatchEvent(new CustomEvent('wallet-reauth-needed'));
      }
    }

    // Extraer mensaje de error del servidor
    const message = error.response?.data?.error ||
                   error.response?.data?.message ||
                   error.message ||
                   'Error de conexion';

    return Promise.reject({
      status: error.response?.status,
      message,
      data: error.response?.data
    });
  }
);

export default api;
